import type { ConversationNodeQueue } from 'lib-shared-types-api';

type RoutedThroughQueueProps = {
  node: ConversationNodeQueue;
};

export function RoutedThroughQueue({
  node,
}: RoutedThroughQueueProps): JSX.Element {
  return (
    <>
      Queue · Added to <strong>{node.label}</strong>
    </>
  );
}
